import { BigNumber } from '@ethersproject/bignumber';
import BURN_REDEEM_1155_V1_ABI from '@manifoldxyz/typed-contracts/abis/burnredeem/BURN_REDEEM_1155_V1_ABI.json';
import BurnRedeemExtensionContractCore, { BurnRedeemOnChain, BurnToken } from './burnRedeemExtensionCore';
import { NULL_BYTES32 } from '@/common/constants';
import { TransactionResponse } from '@ethersproject/providers';

/*
 * The data structure returned by the contract
 */
type BurnRedeemLegacy1155 = {
  burnTokenAddress: string;
  burnTokenId: BigNumber;
  burnAmount: number;
  redeemTokenId: BigNumber;
  redeemAmount: number;
  redeemedCount: number;
  totalSupply: number;
  startDate: number; // this is in seconds unix epoch
  endDate: number; // this is in seconds unix epoch
  storageProtocol: number;
  location: string;
};


export default class BurnRedeemExtensionContract1155V1 extends BurnRedeemExtensionContractCore {
  ABI = BURN_REDEEM_1155_V1_ABI;

  constructor(extensionContractAddress: string) {
    super(extensionContractAddress);
  }

  async getBurnRedeem(
    redeeemContractAddress: string,
    burnIndex: string,
  ): Promise<BurnRedeemOnChain> {
    const legacyBR: BurnRedeemLegacy1155 = await this._callWeb3WithServerFallback(
      this.extensionContractAddress,
      this.ABI,
      'getBurnRedeem',
      [redeeemContractAddress, burnIndex],
      true,
    );

    return {
      paymentReceiver: '',
      storageProtocol: legacyBR.storageProtocol,
      redeemedCount: legacyBR.redeemedCount,
      redeemAmount: legacyBR.redeemAmount,
      totalSupply: legacyBR.totalSupply,
      startDate: legacyBR.startDate, // this is in seconds unix epoch
      endDate: legacyBR.endDate, // this is in seconds unix epoch
      cost: BigNumber.from(0),
      location: legacyBR.location,
      burnSet: [
        {
          requiredCount: BigNumber.from(1),
          items: [
            {
              validationType: 2,
              contractAddress: legacyBR.burnTokenAddress,
              tokenSpec: 2,
              burnSpec: 1,
              amount: BigNumber.from(legacyBR.burnAmount),
              minTokenId: legacyBR.burnTokenId,
              maxTokenId: legacyBR.burnTokenId,
              merkleRoot: NULL_BYTES32,
            },
          ],
        },
      ],
    } as BurnRedeemOnChain;
  }

  async burnRedeem(
    account: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    creatorContractAddress: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    index: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    burnRedeemCount: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    burnTokens: BurnToken[], // eslint-disable-line @typescript-eslint/no-unused-vars
    fee: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    cost: string, // eslint-disable-line @typescript-eslint/no-unused-vars
  ): Promise<TransactionResponse | undefined> {
    throw new Error('Use safe transfer, burnRedeem is not implemented');
  }

  async burnRedeemOverload(
    account: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    creatorContractAddresses: string[], // eslint-disable-line @typescript-eslint/no-unused-vars
    indices: string[], // eslint-disable-line @typescript-eslint/no-unused-vars
    burnRedeemCounts: string[], // eslint-disable-line @typescript-eslint/no-unused-vars
    burnTokens: BurnToken[][], // eslint-disable-line @typescript-eslint/no-unused-vars
    fee: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    cost: string, // eslint-disable-line @typescript-eslint/no-unused-vars
  ): Promise<TransactionResponse | undefined> {
    throw new Error('Not implemented');
  }
}
